import { BillingItem, InformationItem } from '../../types';

export const allInvoices: BillingItem[] = [
  {
    date: '22 Aug, 2024',
    interval: 'Monthly',
    price: '345',
    status: 'Open',
  },
  {
    date: '22 Aug, 2024',
    interval: 'Monthly',
    price: '345',
    status: 'Open',
  },
  {
    date: '22 Aug, 2024',
    interval: 'Monthly',
    price: '345',
    status: 'Open',
  },
  {
    date: '22 Aug, 2024',
    interval: 'Monthly',
    price: '345',
    status: 'Open',
  },
  {
    date: '22 Aug, 2024',
    interval: 'Monthly',
    price: '345',
    status: 'Open',
  },
  {
    date: '22 Aug, 2024',
    interval: 'Monthly',
    price: '345',
    status: 'Open',
  },
  {
    date: '22 Aug, 2024',
    interval: 'Monthly',
    price: '345',
    status: 'Open',
  },
];

export const billingAddress: InformationItem[] = [
  {
    icon: 'A',
    title: 'Billing Email Address',
    value: 'Mehran@ai-bees.io',
  },
  {
    icon: 'A',
    title: 'Company Name',
    value: 'AI bees',
  },
  {
    icon: 'A',
    title: 'Address ',
    value: '3180 Station Street, Austin, TX',
  },
  {
    icon: 'A',
    title: 'City',
    value: ' Austin, TX',
  },
  {
    icon: 'A',
    title: 'Country',
    value: 'United State',
  },
  {
    icon: 'A',
    title: 'Postal Code',
    value: '81723',
  },
  {
    icon: 'A',
    title: 'Description',
    value: '-',
  },
];

export const billingOverview: InformationItem[] = [
  {
    icon: 'A',
    title: 'Total Price',
    value: '$345',
  },
  {
    icon: 'A',
    title: 'Billing Cycle',
    value: 'Monthly',
  },
  {
    icon: 'A',
    title: 'Expiry Date',
    value: '2024/12/04',
  },
  {
    icon: 'A',
    title: 'Billing Status',
    value: 'Up-to-date',
  },
  {
    icon: 'A',
    title: 'Subscription Start Date',
    value: '2024/12/04',
  },
  {
    icon: 'A',
    title: 'Subscription Status',
    value: 'Active',
  },
  {
    icon: 'A',
    title: 'Credit Card Status',
    value: 'Active',
  },
  {
    icon: 'A',
    title: 'Payment Method',
    value: 'Paypal',
  },
  {
    icon: 'A',
    title: 'Payment Card',
    value: 'Master Card | Expires 12/43',
  },
  {
    icon: 'A',
    title: 'Last Payment date',
    value: '2024/12/04',
  },
  {
    icon: 'A',
    title: 'Next Payment due date',
    value: '2024/12/04',
  },
  {
    icon: 'A',
    title: 'Payment Issue',
    value: 'No Issue',
  },
];
